import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Skeleton from '@material-ui/lab/Skeleton';
import { useTourDescription, useTourDescriptionStore, useTourExtras, useTourVariant } from '../../../store/TourDescriptionStore';
import { LightboxThumbnail } from '../LightboxThumbnail';
import { _T } from 'appI18n';
import React, { Fragment, useCallback, useMemo } from 'react';
import { formatMoney } from 'utils';
import { getExtraCost } from '../Extras/ExtrasContainer';
import { Badge, Tooltip } from '@material-ui/core';
import { _ParentFrame } from '../../../../Frame/types/Frame';
import { tourDetailsUrlRR } from '../../../tour-urlgen';
import { useHistory, useLocation, useParams } from 'react-router-dom';
export const useRoomStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(1),
        boxShadow: 'none',
        border: '1px solid #dadada',
    },
    price: {
        fontSize: '1.4rem',
    },
    current: {
        display: 'flex',
        alignItems: 'center',
        padding: '4px 0 8px',
        marginLeft: 4,
        color: theme.palette.success.main,
        '& > :last-child': { marginRight: theme.spacing(.5) }
    }
}));
function HotelRoom({ room, basePrice, basePriceCurrency, isFrame }) {
    const location = useLocation();
    const history = useHistory();
    const params = useParams();
    const desc = room.description;
    const [{ currentAccommodationVariants: accmds, tourVariant }] = useTourVariant(isFrame);
    const [{ excursionServices, hash, externalFlight, externalFlightId, externalFlightProviderId, tourDescription: { id: tourId, name: tourName } }, actions] = useTourDescription(null, isFrame);
    const [{ search }] = useTourDescriptionStore(isFrame);
    const [{ extras, price }] = useTourExtras(isFrame);
    const excursionServicesString = useMemo(() => (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) > 0 ? excursionServices.map(e => `${e.id}__${e.beginDate}=${(e.currentVehicleTypeId == undefined ? '' : e.currentVehicleTypeId)}`).reduce((pr, curr) => `${pr};${curr}`) : "", [excursionServices]);
    const classes = useRoomStyles();
    const variants = useMemo(() => {
        return room.variants.sort((a, b) => a.accomodation.price - b.accomodation.price);
    }, [room.variants, excursionServices, hash]);
    const tourUrl = useCallback((hash) => {
        return tourDetailsUrlRR(tourId, {
            tourName: tourName,
            //accmmdId: recommendation.accmmdVariantIdForBestPrice,
            //variantId: recommendation.tourVariantIdForBestPrice,
            state: location.state,
            excursions: excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.map(s => ({ id: s.id, vehicleTypeId: s.currentVehicleTypeId })),
            hash: hash,
            externalFlight: externalFlight !== null && externalFlight !== void 0 ? externalFlight : (externalFlightId && externalFlightProviderId ? { flightId: externalFlightId, providerId: externalFlightProviderId } : undefined),
            extras: extras,
            search: search,
        }, params['frameId']);
    }, [tourName, tourId, location.state, excursionServicesString, params['frameId'], externalFlight, externalFlightId, externalFlightProviderId]);
    //const handleSelectClicked = (accmmdId: string) => {
    //    // TODO hash
    //    changeAccommodation(room.variants.find(x => x.accomodation.id == accmmdId)!.accomodation);
    //}
    const handleSelectClicked = (hash) => {
        //history.replace(tourUrl(hash));
        actions.setPriceItem(hash);
    };
    const fullPrice = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        // TODO
        let p = basePrice;
        if (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) {
            for (let i = 0; i < excursionServices.length; i++) {
                let exc = excursionServices[i];
                let price = (_a = exc.excursionPrice) !== null && _a !== void 0 ? _a : (_b = exc.prices) === null || _b === void 0 ? void 0 : _b.find(ep => ep.vehicleTypeId == exc.currentVehicleTypeId);
                let defaultPrice = (_d = (_c = exc.prices) === null || _c === void 0 ? void 0 : _c.find(ep => ep.vehicleTypeId == exc.vehicleTypeId)) !== null && _d !== void 0 ? _d : (_e = exc.prices) === null || _e === void 0 ? void 0 : _e.find(ep => ep.vehicleTypeId == 0);
                p += (((_f = price === null || price === void 0 ? void 0 : price.price) !== null && _f !== void 0 ? _f : 0) - ((_g = defaultPrice === null || defaultPrice === void 0 ? void 0 : defaultPrice.price) !== null && _g !== void 0 ? _g : 0));
            }
        }
        if (price && tourVariant)
            p += Object.keys(extras).map(e => getExtraCost(e, extras, price, tourVariant)).reduce((c, p) => c + p, 0);
        //p += price!.extras.filter(e => extras[getExtraKey(e)]?.length).map(e => e.cost * (e.isGroupCost ? 1 : extras[getExtraKey(e)]!.length)).reduce((c, p) => c + p, 0);
        return p + ((externalFlight === null || externalFlight === void 0 ? void 0 : externalFlight.flightCostDifference) || 0);
    }, [basePrice, excursionServices, excursionServicesString, hash, extras]);
    return (React.createElement(Paper, { className: classes.root },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, md: 2, sm: 3 },
                React.createElement(LightboxThumbnail, { images: room.description.roomImages, height: 80, onImageClick: isFrame ? () => {
                        var _a, _b, _c, _d;
                        const parentFrame = _ParentFrame();
                        parentFrame.sendMessage({ message: 'open-gallery', params: { hotelId: (_b = (_a = room.variants[0]) === null || _a === void 0 ? void 0 : _a.accomodation) === null || _b === void 0 ? void 0 : _b.hotelId, roomTypeId: room.description.roomTypeId, roomCategoryId: room.description.roomCategoryId, externalRoomProviderId: (_c = room.variants[0].externalHotelPrice) === null || _c === void 0 ? void 0 : _c.providerId, externalRoomVariantId: (_d = room.variants[0].externalHotelPrice) === null || _d === void 0 ? void 0 : _d.id } });
                    } : undefined })),
            React.createElement(Grid, { item: true, md: 10, sm: 9 },
                React.createElement(Typography, { variant: "h6" }, desc.name),
                React.createElement(Typography, { variant: "body1" },
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: desc.description } })),
                React.createElement(Typography, { variant: "body1" }, desc.equipment))),
        React.createElement(Box, { my: 2 },
            React.createElement(Divider, null)),
        variants.map(({ hash: variantHash, accomodation: x, totalVariantPrice, promoName, externalHotelPrice }, i) => {
            const isCurrentVariant = hash == variantHash;
            return React.createElement(Fragment, { key: i },
                React.createElement(Grid, { container: true, key: i, alignItems: "center" },
                    React.createElement(Grid, { item: true, md: 2, sm: 3 }, x.mealTypeName),
                    React.createElement(Grid, { item: true, md: 2, sm: 2 }, x.availability == 0 ? _T.TOUR_AVAILABLE : _T.TOUR_ONREQUEST),
                    React.createElement(Grid, { item: true, md: 3, sm: 1 }, promoName ?
                        React.createElement("span", { title: promoName, className: "promo-highlight-cart" },
                            "\u00A0PROMO\u00A0",
                            React.createElement("i", { className: "fa fa-tag opacity-80", "aria-hidden": "true" }),
                            "\u00A0") : null),
                    React.createElement(Grid, { item: true, md: 3, sm: 5, className: classes.price }, promoName && undefined
                        ? React.createElement(Badge, { variant: "standard", color: "error", badgeContent: React.createElement(Tooltip, { title: promoName },
                                React.createElement(Typography, { variant: "caption" },
                                    "\u00A0PROMO\u00A0",
                                    React.createElement("i", { className: "fa fa-tag opacity-80", "aria-hidden": "true" }),
                                    "\u00A0")) },
                            formatMoney(fullPrice + totalVariantPrice, { currency: basePriceCurrency.name }),
                            "\u00A0",
                            basePriceCurrency.name)
                        : React.createElement(React.Fragment, null,
                            formatMoney(fullPrice + totalVariantPrice, { currency: basePriceCurrency.name }),
                            "\u00A0",
                            basePriceCurrency.name)),
                    React.createElement(Grid, { item: true, xs: 2 }, !isCurrentVariant
                        ? React.createElement(Button, { color: "secondary", variant: "outlined", fullWidth: true, onClick: handleSelectClicked.bind(null, variantHash) },
                            _T.COMMON_CHOOSE,
                            " ",
                            React.createElement(ChevronRightIcon, null))
                        : React.createElement(Typography, { className: classes.current, variant: "button", component: "div" },
                            React.createElement(CheckIcon, null),
                            " ",
                            _T.TOUR_SELECTED))),
                variants.length - 1 > i && React.createElement(Box, { my: 1 },
                    React.createElement(Divider, null)) || null);
        })));
}
export function HotelRoomVariantsSkeleton({ count }) {
    const elems = [];
    for (let i = 0; i < count; ++i) {
        elems.push(React.createElement(Box, { mt: 1, key: i },
            React.createElement(Skeleton, { variant: "rect", height: 250 })));
    }
    return React.createElement("div", null, elems);
}
export default function HotelRoomVariants(props) {
    return React.createElement("div", null,
        !props.rooms.length && _T.COMMON_NO_RESULTS,
        props.rooms.map(x => React.createElement(HotelRoom, { room: x, basePrice: props.basePrice, basePriceCurrency: props.basePriceCurrency, key: `${x.description.roomCategoryId}-${x.description.roomTypeId}`, isFrame: props.isFrame, hash: props.hash })));
}
